// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrongAlert_S_8m9 {
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 5px;
  min-height: 38px;
  background-color: #FEF5E5;
  border: 0px solid #d0d0d0;
}

.leftSide_LF8Hr {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4px;
  height: 38px;
  background: #7C5400;
}

.iconContainer_w41vR {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.icon_xkR97 {
  width: 24px;
  height: 24px;
}

.messageContainer_CslWx {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.message_xStZA {
  font-size: 14px;
  line-height: 16px;
  color: #4F5660;
}

.buttonClose_IjbuE {
  background-color: transparent;
  border: none;
  color: #0065f1;
  text-decoration: underline;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/WrongAlert/WrongAlert.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,UAAU;AACZ","sourcesContent":[".wrongAlert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border-radius: 5px;\n  min-height: 38px;\n  background-color: #FEF5E5;\n  border: 0px solid #d0d0d0;\n}\n\n.leftSide {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 4px;\n  height: 38px;\n  background: #7C5400;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n}\n\n.messageContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.message {\n  font-size: 14px;\n  line-height: 16px;\n  color: #4F5660;\n}\n\n.buttonClose {\n  background-color: transparent;\n  border: none;\n  color: #0065f1;\n  text-decoration: underline;\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrongAlert": `wrongAlert_S_8m9`,
	"leftSide": `leftSide_LF8Hr`,
	"iconContainer": `iconContainer_w41vR`,
	"icon": `icon_xkR97`,
	"messageContainer": `messageContainer_CslWx`,
	"message": `message_xStZA`,
	"buttonClose": `buttonClose_IjbuE`
};
export default ___CSS_LOADER_EXPORT___;
